enum FeeStatusEnum {
	PAID = 'PAID',
	NOT_PAID = 'NOT_PAID',
	NOT_REQUIRED = 'NOT_REQUIRED',
	TO_BE_DECIDED = 'TO_BE_DECIDED',
	PENDING_EXTERNAL_PAYMENT = 'PENDING_EXTERNAL_PAYMENT'
}

export default FeeStatusEnum;
